import { useCallback } from 'react'

import { AppToastVariant, publishAppToast } from '../utils/appToastBus'

export function useAppToast() {
  const showToast = useCallback((message: string, variant: AppToastVariant = 'success') => {
    publishAppToast(message, variant)
  }, [])

  const showSuccessToast = useCallback((message: string) => showToast(message, 'success'), [showToast])

  const showErrorToast = useCallback((message: string) => showToast(message, 'error'), [showToast])

  return { showErrorToast, showSuccessToast, showToast }
}
